import { styled } from '@linaria/react';

import { Text } from '~components/Typography';
import { ButtonIconGhost } from '~shared/ui/atoms/Buttons/ButtonGhost/Icon';

export const Wrapper = styled.div`
	position: absolute;
	top: calc(6rem + var(--header-offset));
	right: 1rem;
	display: flex;
	overflow: auto;
	width: 27.2rem;
	flex-direction: column;
	padding: 1.2rem;
	border-radius: var(--radius-l);
	backdrop-filter: blur(25px);
	background-color: var(--color-grey-6-xl);
`;

export const StyledTitle = styled(Text)`
	padding: 0.6rem 1.2rem 1.8rem;
`;

export const Divider = styled.div`
	flex-grow: 1;
	padding-bottom: 0.8rem;
	border-top: 1px var(--color-grey-19-solid) solid;
	margin: 0 0.8rem;
`;

export const CloseButton = styled(ButtonIconGhost)`
	position: absolute;
	top: 1.1rem;
	right: 1rem;
`;

export const Item = styled.button`
	position: relative;
	padding: 0.8rem 4rem 0.8rem 1.2rem;
	border-radius: var(--radius-xs);
	margin-top: 0.4rem;

	&:hover {
		background-color: var(--color-white-m);
	}

	&.selected {
		pointer-events: none;
	}

	& svg {
		position: absolute;
		top: 50%;
		right: 0.9rem;
		transform: translateY(-50%);
	}
`;
